import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';


import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { contactPay,payMeth } from '../../../slices/modalSlice';




class ContactPayModal extends Component {

    constructor(props) {
        super(props);
      }
 


    toogleClose = () =>this.props.dispatch(contactPay())

    payMeth = () => this.props.dispatch(payMeth())
    
    precedContactPay = () => {
      this.toogleClose();
      this.payMeth()
    }

    
    render() {
      
        return (
            <div>
              <Modal isOpen={this.props.contactPay} toggle={this.toogleClose} contentClassName="reserveModal" centered={true}>
                   <ModalHeader className="modalHeader contactPayHeader d-flex justify-content-center align-items-center" ><center className="text-center contactPayTxt">Paiement</center></ModalHeader>
                   <ModalBody className="d-flex flex-column justify-content-center align-items-center">
                      <p className="text-center" id="especes"><img id="especesImg" src="/imgs/resrervationIcons/especes.png" alt="Espèces"/>Espèces</p>
                      <p className="text-center contactPayInfos hasmarg grayTxt">Veuillez nous contacter sur les numéros suivants</p>
                      <p className="text-center contactPayInfos grayTxt">+213 (0) 38 75 75 75</p>
                      <p className="text-center contactPayInfos grayTxt">+213 (0) 661 661 661</p>
                      <p className="text-center contactPayInfos hasmarg grayTxt">+213 (0) 770 770 770</p>
                      <p className="text-center contactPayInfos hasmarg grayTxt">Vous pouvez aussi vous rapprocher de notre siège cis
                         à Skikda, Bvd. Houari Boumedien, 180 logt. Bt C. N10
                      </p>
    
                      <Button onClick={this.precedContactPay} className="contactPayBtns precedBtn d-flex align-items-center justify-content-between">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="17" viewBox="0 0 14.839 29.677">
                          <path id="Tracé_521" data-name="Tracé 521" d="M0,0,7.652,10.652,0,21.3" transform="translate(10.652 25.491) rotate(180)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="6"/>
                        </svg>

                        <span>Précédent</span>
                        <span></span>
                      </Button>
                      <Button onClick={this.toogleClose} className="contactPayBtns annulerBtn d-flex justify-content-center"><span className="ml-2">Annuler</span></Button>
                   </ModalBody>
              </Modal>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
      
      contactPay : state.modal.contactPay
      
    }
  }
export default withRouter(connect(mapStateToProps)(ContactPayModal));
